import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <img
        src={`${process.env.PUBLIC_URL}/footer.png`}
        alt="Boehringer Ingelheim - Información legal y de contacto"
        className={styles.footerImage}
      />
    </footer>
  );
}
